module.exports = __webpack_public_path__ + "static/media/imagenet4.2a1f7932.png";